/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useEffect, useState } from "react";
import { BsPencilSquare } from "react-icons/bs";
import MobileViewTable from "../../../MobileViewTable";
import "../../../../assets/css/admin/countries and offices/AreasTable.css";
import { useTranslation } from "react-i18next";
import fetchClient from "../../../../axios/fetch";

const AreasTable = ({
  officeData,
  setAreaToEdit,
  setAreasMode,
  setAreasNotif,
  getAllAreas,
}) => {
  const [areasData, setAreasData] = useState([]);
  const [currentWidth, setCurrentWidth] = useState(window.innerWidth);
  const [currentNum, setCurrentNum] = useState(0);
  const { t } = useTranslation();
  const [entityData, setEntityData] = useState([]);

  const cityId = localStorage.getItem("city");
  useEffect(() => {
      fetchClient()
      .get(`api/entity/city/${cityId}`)
      .then((res) => {
        const entities = res?.data?.data || [];
        const filterActiveEntities = entities.filter((entity) => entity.isActive);
        setEntityData(
          filterActiveEntities.map((entity) => ({
            id: entity.id,
            entityName: entity.entityName,
          }))
        );
      })
      .catch(() => {
        setEntityData([]);
      });
  }, []);

  useEffect(() => {
    const entitiesById = entityData.reduce((acc, entity) => {
      acc[entity.id] = entity.entityName;
      return acc;
    }, {});

    setAreasData(
      officeData.areas
        ?.map((area) => {
          let areaType;
          switch (area.areaType) {
            case "individual":
              areaType = t("individual");
              break;
            case "meeting room":
              areaType = t("meeting_room");
              break;
            case "meeting pod":
              areaType = t("meeting_pod");
              break;
            default:
              break;
          }

          const entityNamesList = Array.isArray(area.entityIds)
            ? area.entityIds
                .map((entityId) => entitiesById[entityId])
                .filter(Boolean)
            : [];

          const entityNames = entityNamesList.length
            ? entityNamesList.join(", ")
            : "N/A";

          return {
            ...area,
            areaType: areaType ? areaType[0].toUpperCase() + areaType.slice(1) : "",
            entityName: entityNames,
            seatRange: `${area.seatMinRange} - ${area.seatMaxRange}`,
          };
        })
        .sort((a, b) => (a.seatMinRange > b.seatMinRange ? 1 : -1))
    );
  }, [officeData.areas, entityData]);

  useEffect(() => {
    const handleWindowResize = () => setCurrentWidth(window.innerWidth);

    window.addEventListener("resize", handleWindowResize);
  }, [currentWidth]);

  //data for mobile view
  const topLabels = [
    {
      label: t("edit"),
      data: () => (
        <BsPencilSquare
          onClick={() => {
            setAreasMode("edit");
            setAreaToEdit({
              ...areasData[currentNum],
              areaType: areasData[currentNum].areaType.toLowerCase(),
            });
          }}
          className="editIcon"
        />
      ),
    },
    {
      label: t("areaType"),
      data: "areaType",
    },
    {
      label: t("area_name"),
      data: "roomName",
    },
    {
      label: t("entity_name"),
      data: "entityName",
    },
    {
      label: t("Capacity"),
      data: "capacity",
    },
    {
      label: t("Seat_range"),
      data: "seatRange",
    },
  ];
  const botLabels = [
    {
      label: t("area_name"),
      data: "roomName",
    },
  ];

  // const deleteCell = ({ dataItem }) => {
  //   return (
  //     <td>
  //       <BsTrash
  //         onClick={() => handleDelete(dataItem.id)}
  //         className="deleteIcon"
  //       />
  //     </td>
  //   );
  // };

  const editCell = ({ dataItem }) => (
    <td>
      <BsPencilSquare
        onClick={() => {
          setAreasMode("edit");
          setAreaToEdit({
            ...dataItem,
            areaType: dataItem.areaType.toLowerCase(),
          });
        }}
        className="editIcon"
      />
    </td>
  );

  return (
    <div className="areas-table">
      {currentWidth > 767 ? (
        <Grid data={areasData}>
          {/* <Column title={t("delete")} cell={deleteCell} width={"80px"} /> */}
          <Column title={t("edit")} cell={editCell} width={"80px"} />
          <Column field="areaType" title={t("areaType")} />
          <Column field="roomName" title={t("room_name")} />
          <Column field="entityName" title={t("entity_name")} />
          <Column field="capacity" title={t("Capacity")} />
          <Column field="seatRange" title={t("Seat_range")} />
        </Grid>
      ) : (
        <MobileViewTable
          currentNum={currentNum}
          setCurrentNum={setCurrentNum}
          data={areasData}
          topLabels={topLabels}
          botLabels={botLabels}
        />
      )}
      {/* {showDelete && (
        <DeleteAreaDialog
          area={selected.roomName}
          setAreasNotif={setAreasNotif}
          toggleDialog={toggleDeleteDialog}
          handleSaveDelete={handleSaveDelete}
        />
      )} */}
    </div>
  );
};

export default AreasTable;
